import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { MouService } from './mou.service';
import { MOUVm } from '../../generated/Administration/Models/Events/MOUVm';
import { SystemMessage, SystemMessageService } from '../../../core/system-message/system-message-service';
import { UserJsVm } from '../../generated/Administration/Models/User/JavaScript/UserJsVm';
import { SecurityService } from '../../../core/security/security.service';

@Component({
    selector: 'pcg-mou-ack',
    templateUrl: './mou-ack.component.html',
    styleUrls: ['./mou-ack.component.scss'],
    standalone: false
})
export class MouAckComponent implements OnInit, OnDestroy {

	user!: UserJsVm;
	ackLanguage!: string;
	subscriptions: Subscription[] = [];
	eventId = 0;
	eventName!: string;

	constructor(
		private mouService: MouService
		, private sec: SecurityService
		, public ms: SystemMessageService
		, public modalService: NgbActiveModal
	) {}

	ngOnInit(): void {
		this.getJsUser();
		this.getAckLanguage();
	}

	saveAcknowledgement() {
		this.subscriptions.push(
			this.mouService.saveAcknowledgement(this.user.id, this.eventId).subscribe((msg: SystemMessage) => {
				this.user.hasAcknowledgedMOU = true;
				const val = msg.value;
				this.sec.setSecurity(val.token, val.user, val.security);
				this.modalService.close();
			})
		);
	}

	getJsUser(): void {	
		this.subscriptions.push(this.sec.user$.subscribe(user => { 
			this.user = user; 
			this.eventId = user?.currentEventId;
		})); 
	}

	getAckLanguage(): void {
		this.subscriptions.push(
			this.mouService.getModel(this.eventId).subscribe((vm: MOUVm) => { 
				this.ackLanguage = vm.memorandumLanguage!; 
				this.eventName = vm.eventName!;
			})
		);
	}

	ngOnDestroy(): void { this.subscriptions.forEach(x => x.unsubscribe()); }
}
